const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSteps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 266.667,
    height: 266.667,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 850.08 850.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M467.53 558.48c28.77 9.85 54.17 16.12 90.67 27.33-14.02 177.16-181.54 106.81-90.67-27.33zM617.1 395.74c-1.89-53.2-11.27-122.97-85.88-112.04-34.98 9.13-60.84 47.55-72.99 113.84-6.68 36.44-2.8 87.6 5.08 118.27 7.19 21.61 4.75 20.28 12.47 24.39 29.92 6.74 59.53 14.2 89.69 21.81 30.64-21.64 55.8-136.5 51.63-166.27v.01zm-230.31-4.08c7.87-30.67 11.75-81.83 5.08-118.27-12.15-66.29-38-104.72-72.99-113.84-74.63-10.93-84 58.84-85.88 112.04-4.17 29.76 21 144.64 51.63 166.27 30.16-7.6 59.77-15.06 89.69-21.8 7.72-4.1 5.28-2.77 12.46-24.39v-.01zm-94.9 70.01c14.02 177.16 181.53 106.8 90.66-27.34-28.77 9.86-54.17 16.13-90.66 27.34z",
    style: {
      fill: "#cd1a1e",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.04 0c234.74 0 425.04 190.3 425.04 425.04s-190.3 425.04-425.04 425.04S0 659.78 0 425.04 190.3 0 425.04 0zm276.51 148.53C630.79 77.77 533.03 34 425.04 34c-107.98 0-205.75 43.77-276.51 114.53C77.77 219.29 34 317.05 34 425.04c0 107.98 43.77 205.75 114.53 276.51 70.76 70.76 168.52 114.53 276.51 114.53 107.98 0 205.75-43.77 276.51-114.53 70.76-70.76 114.53-168.52 114.53-276.51 0-107.98-43.77-205.75-114.53-276.51z",
    style: {
      fill: "#cd1a1e"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteps);
export default __webpack_public_path__ + "static/media/Steps.d80e6379d1072b55adc587b06a9473d0.svg";
export { ForwardRef as ReactComponent };